import { portfolioLocations } from 'data/portfolioLocations';

export const pages = [
  {
    title: 'Navigation',
    id: 'supporting-pages',
    pages: [
      {
        title: 'Home',
        href: '/',
      },
      {
        title: 'About',
        href: '/about',
      },
      {
        title: 'Portfolio',
        href: '/portfolio',
        children: portfolioLocations,
      },
      {
        title: 'Contact',
        href: '/contact',
      },
    ],
  },
];
